import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../auth/AuthContext';
import { apiLogin } from '../../data/api';
import { loginStyles } from './login.style';
import { Role, Status } from '../../data/types/medico.types';
import { LabelApp } from '../../pagesApp/Layout.app';
 
const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { login, logout } = useAuth();
  const navigate = useNavigate();
 
  useEffect(() => {
	logout()
  }, [])
 
  const handleUsernameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
	const value = e.target.value;
	
	// Permitir valores vacíos
	if (value === '') {
	  setUsername('');
	  return;
	}
	
	// Validar: solo números, máximo 10 dígitos
	const isValid = /^\d{1,10}$/.test(value);
	
	// Si es válido, actualizar; si no, mantener el valor anterior
	if (isValid) {
	  setUsername(value);
	}
  };

  const handleSubmit = async (e: React.FormEvent) => {
	e.preventDefault();
	setIsLoading(true);
	setError('');

	try {
	  // TODO: Mover esto a un lugar mas apropiado...
	  const {data: loginResponse} = await apiLogin.post('/api/authm/login', { dni: username, password });

	  const token = loginResponse.role === Role.ADMIN || loginResponse.status === Status.APROBADO ? loginResponse.token : undefined

	  login( token, `${loginResponse.nombre} ${loginResponse.apellido}`, loginResponse.role);
	   
	  if (loginResponse.status === Status.PENDIENTE) navigate('/med/registerm/pending')
	  if (loginResponse.status === Status.RECHAZADO) navigate('/med/registerm/rechazado')
	  if (loginResponse.role === Role.ADMIN) navigate('/med/dashboard');
	  if (loginResponse.status === Status.APROBADO) navigate('/med/dashboard');
	} catch (err) {
	  console.log("### error", err)
	  setError('Credenciales incorrectas');
	} finally {
	  setIsLoading(false);
	}
  };
 
  return (
	<div style={loginStyles.container}>
	  <div style={loginStyles.formContainer}>
		<h2 style={loginStyles.title}>Bienvenido a Kaiteki</h2>
		<h1 style={loginStyles.title}>Portal de Médicos</h1>
		<form onSubmit={handleSubmit}>
		  <LabelApp label="Número de DNI" />
		  <input
			type="text"
			placeholder="DNI"
			style={loginStyles.input}
			value={username}
			onChange={handleUsernameChange}
			required
		  />
		  <LabelApp label="Contraseña" />
		  <input
			type="password"
			placeholder="Contraseña"
			style={loginStyles.input}
			value={password}
			onChange={(e) => setPassword(e.target.value)}
			required
		  />
		   
		  <button 
			type="submit" 
			style={loginStyles.button}
			disabled={isLoading}
		  >
			{isLoading ? (
			  <div style={loginStyles.loader} />
			) : (
			  'Ingresar'
			)}
		  </button>
 
		  	{error && <p style={loginStyles.error}>{error}</p>}
		  	<div style={{ 
				marginTop: '1rem', 
				display: 'flex', 
				flexDirection: 'column', 
				gap: '0.5rem' 
			}}>
				<span style={{ display: 'flex', justifyContent: 'center', gap: '0.5rem' }}>¿No tienes una cuenta?<a 
					href="/med/registerm" 
					style={{ 
						color: '#3A8DFF', 
						textAlign: 'center', 
						fontWeight: 500 
					}}>
						Registrate
					</a></span>
				<a 
					href="/med/forgot-pass/send-code" 
					style={{ 
						color: '#3A8DFF', 
						textAlign: 'center', 
						fontWeight: 500, 
						marginTop: 12 
					}}>
						<LabelApp label="Olvidé la contraseña" />
					</a>
		  </div>
		  </form>
		</div>
 
	  {/* Animación CSS para el loader */}
	  <style>
		{`
		  @keyframes spin {
			0% { transform: rotate(0deg); }
			100% { transform: rotate(360deg); }
		  }
		   
		  /* Asegurar que inputs y botones tengan el mismo box model */
		  input, button {
			box-sizing: border-box;
		  }
		`}
	  </style>
	</div>
  );
};
 
export default Login;